import React from "react";
import { observer } from "mobx-react";
import { NikoFacilityOrderOrderSummaryPreviewTemplate } from "themes/application/niko-facility-order-order-summary/pages";
import { NikoFacilityOrderOrderSummaryPreviewViewStore } from "application/niko-facility-order-order-summary/stores";
import { setCurrentView } from "core/utils";

@setCurrentView(rootStore => new NikoFacilityOrderOrderSummaryPreviewViewStore(rootStore), "nikoFacilityOrderOrderSummaryPreviewViewStore")
@observer
class NikoFacilityOrderOrderSummaryPreview extends React.Component {
	render() {
		return <NikoFacilityOrderOrderSummaryPreviewTemplate {...this.props} />;
	}
}

export default NikoFacilityOrderOrderSummaryPreview;